/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { style } from "./style";
var type;
(function (type) {
    type["phone"] = "phone";
    type["idCard"] = "idCard";
})(type || (type = {}));
export class PrivacyInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mask: true
        };
        this.inputAttr = {};
        this.inputRef = React.createRef();
        this.initInput();
    }
    // 初始化input属性
    initInput() {
        const { type } = this.props;
        if (type === "phone") {
            this.inputAttr = {
                type: "tel",
                maxLength: 11,
                placeholder: "请输入手机号码"
            };
        }
        if (type === "idCard") {
            this.inputAttr = {
                type: "text",
                maxLength: 18,
                placeholder: "请输入身份证号码"
            };
        }
    }
    // 隐私数据处理
    dataToPrivacy(type, value) {
        // type: phone 手机号类型，长度11，例子：150****5716
        if (type === "phone" && value.length === 11) {
            return value.replace(/^(\d{3})\d*(\d{4})/, "$1****$2");
        }
        // type: idCard 身份证号类型，长度18，例子：330***********2317
        if (type === "idCard" && value.length === 18) {
            return value.replace(/^(\d{3})\d*(\d{3}.)/, "$1***********$2");
        }
        return "";
    }
    hidePrivacyMask() {
        this.setState({
            mask: false
        });
        // 设置内容为空
        this.props.onChange("");
        // input 获焦
        this.inputRef && this.inputRef.current && this.inputRef.current.focus();
        // 遮罩隐藏
        this.props.onHide && this.props.onHide();
    }
    // input 输入
    inputChange(e) {
        // 如果用户输入了，并且当前mask是true，则设置为false
        if (this.state.mask) {
            this.setState({
                mask: false
            });
        }
        this.props.onChange(e.target.value);
    }
    // 检查值是否符合类型
    isValueRight() {
        const { type, value } = this.props;
        // 简单校验下数据是否合理
        if (type === "phone" && value && value.length === 11) {
            return true;
        }
        if (type === "idCard" && value && value.length === 18) {
            return true;
        }
    }
    // 是否展示隐私数据
    shouldShowMask() {
        return this.state.mask && this.isValueRight();
    }
    render() {
        const { type, value, inputAttr, className } = this.props;
        return (jsx("div", { css: style.contain, className: className || "" },
            jsx("input", Object.assign({ ref: this.inputRef, css: style.input }, this.inputAttr, inputAttr, { value: value, onChange: this.inputChange.bind(this) })),
            this.shouldShowMask() ? (jsx("div", { css: style.mask, onClick: this.hidePrivacyMask.bind(this) }, this.dataToPrivacy(type, value || ""))) : null));
    }
}
